import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { lineChartOptions } from '../../variables/charts';

const LineChart = ({ chartData }) => (
  <ReactApexChart
    options={lineChartOptions}
    series={chartData}
    type="area"
    width="100%"
    height="100%"
  />
);

export default LineChart;
